<!-- =========================================================================================
    File Name: Position.vue
    Description: Page to change the node xyz position in a given space
========================================================================================== -->

<template>
  <div>
    <vx-card class="card-no-padding">
      <center class="mt-2 center-top-left">
        <ul>
          <li>
            <vs-radio v-model="controlMode" vs-value="translate">Move</vs-radio>
          </li>
          <li>
            <vs-radio v-model="controlMode" vs-value="rotate">Rotate</vs-radio>
          </li>
          <li>
            <vs-radio v-model="controlMode" vs-value="scale">Scale</vs-radio>
          </li>
        </ul>
      </center>
      <!-- <div class="center-top-right" v-if="this.renderer">{{ this.renderer.info.memory }}</div> -->
      <div v-if="isLoading" class="center-top-right-loading">
        <div class="contained-example-container">
          <div id="div-with-loading" class="vs-con-loading__container"></div>
        </div>
      </div>
      <center
        v-if="selectedNode && selectedNode.pid && this.transformDictionnary[selectedNode.pid]"
        class="center-top-right"
      >
        <div v-if="controlMode == 'translate'">
          x: {{ this.transformDictionnary[selectedNode.pid].position.x.toFixed(2) }}m &nbsp; y:
          {{ this.transformDictionnary[selectedNode.pid].position.y.toFixed(2) }}m &nbsp; z:
          {{ -this.transformDictionnary[selectedNode.pid].position.z.toFixed(2) }}m
          <br />
        </div>
        <div v-if="controlMode == 'rotate'">
          x: {{ radToDeg(-this.transformDictionnary[selectedNode.pid].rotation.x).toFixed(2) }}° &nbsp; y:
          {{ radToDeg(-this.transformDictionnary[selectedNode.pid].rotation.y).toFixed(2) }}° &nbsp; z:
          {{ radToDeg(this.transformDictionnary[selectedNode.pid].rotation.z).toFixed(2) }}°
          <br />
        </div>
        <div v-if="controlMode == 'scale'">
          {{ parseInt(this.transformDictionnary[selectedNode.pid].scale.x * 100) }}%
        </div>

        <!-- <br />
        <br />
        QUATERNION
        <br />

        {{ this.transformDictionnary[selectedNode.pid].quaternion.x.toFixed(3) }}
        <br />

        {{ this.transformDictionnary[selectedNode.pid].quaternion.y.toFixed(3) }}
        <br />

        {{ this.transformDictionnary[selectedNode.pid].quaternion.z.toFixed(3) }}
        <br />

        {{ this.transformDictionnary[selectedNode.pid].quaternion.w.toFixed(3) }}

        <br /> -->
      </center>
      <!-- <center class="center-bottom-left mb-3">
        <div class="vx-col w-full">
          <vx-tooltip text="Make all the object transparent (Editor only)">
            <div class="vx-row">
              <div class="vx-col w-3/12">
                <vs-switch color="success" v-model="use_transparency">
                  Use transparency
                  <span slot="on">On</span>
                  <span slot="off">Off</span>
                </vs-switch>
              </div>
              <div class="vx-col w-9/12">Transparency</div>
            </div>
          </vx-tooltip>
        </div>
      </center> -->
      <div class="scene3d" :id="imageAnchor.pid"></div>
    </vx-card>
  </div>
</template>

<script>
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TransformControls } from 'three/examples/jsm/controls/TransformControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import * as Utils from '@/assets/js/utils/utils.js'
import * as HoverlayUtils from '@/assets/js/utils/hoverlay-utils.js'
import 'video.js/dist/video-js.css'
import * as HoverlayThreeUtils from '@/assets/js/utils/hoverlay-three-utils.js'
import 'flatpickr/dist/flatpickr.css'
import * as DestroyUtils from '@/assets/js/utils/destroy-utils.js'

export default {
  props: {
    selectedNode: null,
    nodes: {},
    imageAnchor: {},
    hobjects: {},
  },
  components: {},
  data() {
    return {
      // Variables for selections
      meshes: [],
      transformDictionnary: [],
      transformControls: null,
      //
      anchor: null,
      hobject: null,
      // usefull to make the camera fit the whole scene
      highest3dObject: 0,
      // Three js variables
      scene3d: null,
      cameraPersp: null,
      cameraOrtho: null,
      currentCamera: null,
      scene: null,
      renderer: null,
      control: null,
      orbit: null,
      CANVAS_HEIGHT: null,
      CANVAS_WIDTH: null,
      trackedImagePixelWidth: null,
      trackedImagePixelHeight: null,
      trackedImageHeight: 1,
      hobjectThumbnailPixelWidth: null,
      hobjectThumbnailPixelHeight: null,
      transformControlDictionnary: [],
      controlMode: 'translate',
      threeJSVideoComponents: [],
      clock: null,
      mixer: null,
      mixerDictionnary: [],
      gltfLoader: null,
      dracoLoader: null,
      isLoading: true,

      // History CTRL-Z CTRL-Y Undo/Repeat
      historyTransformArray: [],
      historyTransformArrayIndex: 0,
    }
  },
  watch: {
    controlMode: function(mode) {
      this.changeTransformControl(mode)
    },
    historyTransformArray: function() {
      this.historyTransformArrayIndex = this.historyTransformArray.length - 1
    },
    nodes: function(newNodes, oldNodes) {
      // Indentify nodes that have been ADDED and add them on the threeJS scene
      var onlynewNewNodes = newNodes.filter(HoverlayUtils.spacesComparer(oldNodes))
      for (const node of onlynewNewNodes) {
        this.createHobjectRepresentation(node)
      }

      // Indentify nodes that have been removed and remove them from the threeJS scene
      // Detach transform first and then remove object from the scene
      var onlyInOldNodes = oldNodes.filter(HoverlayUtils.spacesComparer(newNodes))
      onlyInOldNodes.forEach(node => {
        this.unregisterTransformControl()
        this.transformControls.detach(this.transformDictionnary[node.pid])
        this.transformControls.dispose()
        this.transformControls = null

        if (this.transformDictionnary[node.pid].parent)
          this.transformDictionnary[node.pid].parent.remove(this.transformDictionnary[node.pid])
        else this.scene.remove(this.transformDictionnary[node.pid])
        this.meshes = this.meshes.filter(mesh => mesh.name !== node.pid)
        delete this.mixerDictionnary[node.pid]
        DestroyUtils.disposeHierarchy(
          {
            node: this.transformDictionnary[node.pid],
          },
          DestroyUtils.disposeNode
        )
        this.transformDictionnary[node.pid] = null
        delete this.transformDictionnary[node.pid]
        var selectedObject = this.scene.getObjectByName(node.pid)
        this.scene.remove(selectedObject)

        this.render()
      })
    },
    selectedNode: function(selectedNode) {
      if (selectedNode && selectedNode.pid && this.transformDictionnary[selectedNode.pid]) {
        // Detached controls
        if (this.transformControls != null) {
          // this.SetAllObjectTransparency(1)
          this.transformControls.detach() // <- THIS IS CORRECT
          this.unregisterTransformControl()
          this.scene.remove(this.transformControls)
          delete this.transformControlDictionnary[selectedNode.pid]
        }
        // Add controls on the selected object
        this.addTransformControls(this.transformDictionnary[selectedNode.pid], selectedNode)
        // this.setChildrenMaterielOpacity(this.transformDictionnary[selectedNode.pid], 0.65)

        // If a video is found unmuted it
        var video = document.getElementById(`video_${selectedNode.pid}`)
        if (video) video.muted = false
      }
    },
  },
  computed: {},
  // https://sketchfab.com/3d-models/wooden-artist-mannequin-be47b21c2e8f4a0f975e89a9c50a4aa5
  async mounted() {
    this.$vs.loading({
      container: '#div-with-loading',
      scale: 0.6,
    })

    this.clock = new THREE.Clock()

    // Optional: Provide a DRACOLoader instance to decode compressed mesh data
    this.gltfLoader = new GLTFLoader()
    this.dracoLoader = new DRACOLoader()
    this.dracoLoader.setDecoderPath(`${window.location.origin}/js/draco/`)
    this.gltfLoader.setDRACOLoader(this.dracoLoader)

    await this.$nextTick()
    await this.setupScene()
    this.createControls()
    // this.render()

    if (this.selectedNode == undefined) {
      this.$emit('selectedNode', this.nodes[0])
    }
  },
  created() {
    this.$eventBus.$on('nodePositionChanged', this.onNodePositionChanged)
  },
  beforeDestroy() {
    this.$eventBus.$off('nodePositionChanged')
    this.unregisterTransformControl()

    // Others events
    this.renderer.domElement.removeEventListener('click', this.onDocumentMouseDown, false)

    this.orbit.removeEventListener('change', this.render)
    window.removeEventListener('resize', this.onWindowResize)
    window.removeEventListener('keydown', this.onKeyDown)
    window.removeEventListener('keyup', this.onKeyUp)
    this.mixerDictionnary = null

    DestroyUtils.destroyThreejs({ scene: this.scene, renderer: this.renderer, camera: this.camera })
    this.threeJSVideoComponents = []
  },
  methods: {
    async setupScene() {
      this.scene3d = document.getElementById(this.imageAnchor.pid.toString())
      if (this.scene3d.firstChild) {
        this.scene3d.firstChild.remove()
      }
      this.renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true })
      this.renderer.setPixelRatio(window.devicePixelRatio)

      this.CANVAS_HEIGHT = this.scene3d.offsetHeight
      this.CANVAS_WIDTH = this.scene3d.offsetWidth

      this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_HEIGHT)
      this.scene3d.appendChild(this.renderer.domElement)

      const aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT

      this.cameraPersp = new THREE.PerspectiveCamera(50, aspect, 0.01, 30000)
      this.cameraOrtho = new THREE.OrthographicCamera(-600 * aspect, 600 * aspect, -600, 600, 0.01, 30000)
      this.currentCamera = this.cameraPersp

      this.currentCamera.position.set(0, -0.7, 1)
      this.currentCamera.lookAt(0, 200, 0)

      this.scene = new THREE.Scene()
      const axesHelper = new THREE.AxesHelper(10)
      axesHelper.size = 100
      this.scene.add(axesHelper)

      const light = new THREE.AmbientLight(0xf4f4f4) // soft white light
      this.scene.add(light)

      // How far you can orbit vertically
      // this.orbit.minPolarAngle = Math.PI / 6
      // this.orbit.maxPolarAngle = Math.PI / 1.2

      // How far you can orbit horizontally
      // this.orbit.minAzimuthAngle = -Math.PI / 2
      // this.orbit.maxAzimuthAngle = Math.PI / 2

      this.orbit = new OrbitControls(this.currentCamera, this.renderer.domElement)
      this.orbit.minDistance = 0.1 // the minimum distance the camera must have from center
      this.orbit.maxDistance = 200 // the maximum distance the camera must have from center
      this.orbit.update()

      this.orbit.addEventListener('change', this.render)
      HoverlayThreeUtils.loadReflectionProbe(this)
      await this.createHobjectsRepresentation(this.nodes)
      await this.createTrackedImageRepresentation()
      this.animate()
      this.isLoading = false
      window.addEventListener('keydown', this.onKeyDown)
      window.addEventListener('resize', this.onWindowResize)
      this.adjustCameraDistance()
      var GridHelperVertical
      if (this.highest3dObject < 10) {
        GridHelperVertical = new THREE.GridHelper(1000, 2000, 0xd3d3d3, 0xd3d3d3)
      } else {
        GridHelperVertical = new THREE.GridHelper(1000, 100, 0xd3d3d3, 0xd3d3d3)
      }
      GridHelperVertical.position.set(0, -0.1, 0)
      GridHelperVertical.rotation.set(THREE.MathUtils.degToRad(90), 0, 0)
      this.scene.add(GridHelperVertical)

      // this.adjustGridSize()
    },
    onKeyDown(event) {
      var self = this

      if (event.which === 89 && event.ctrlKey) {
        this.Repeat()
      } else if (event.which === 90 && event.ctrlKey) {
        this.Undo()
      } else if (event.which === 89 && event.metaKey) {
        this.Repeat()
      } else if (event.which === 90 && event.metaKey) {
        this.Undo()
      }

      switch (event.keyCode) {
        case 81: // Q
          self.control.setSpace(self.control.space === 'local' ? 'world' : 'local')
          break

        case 16: // Shift
          if (this.transformControls) {
            this.transformControls.setTranslationSnap(0.1)
            this.transformControls.setRotationSnap(THREE.MathUtils.degToRad(5))
            this.transformControls.setScaleSnap(0.25)
          }
          break
        case 77: // M
          self.controlMode = 'translate'
          break
        case 82: // R
          self.controlMode = 'rotate'
          break
        case 83: // S
          self.controlMode = 'scale'
          break
        case 187:
        case 107: // +, =, num+
          self.control.setSize(self.control.size + 0.1)
          break

        case 189:
        case 109: // -, _, num-
          self.control.setSize(Math.max(self.control.size - 0.1, 0.1))
          break

        // case 88: // X
        //   self.control.showX = !self.control.showX
        //   break

        // case 89: // Y
        //   self.control.showY = !self.control.showY
        //   break

        // case 90: // Z
        //   self.control.showZ = !self.control.showZ
        //   break

        case 32: // Spacebar
          self.control.enabled = !self.control.enabled
          break
      }
    },
    createControls() {
      var self = this
      window.addEventListener('keyup', function(event) {
        switch (event.keyCode) {
          case 16: // Shift
            if (self.transformControls) {
              self.transformControls.setTranslationSnap(null)
              self.transformControls.setRotationSnap(null)
              self.transformControls.setScaleSnap(null)
            }
            break
        }
      })
    },
    mouseUpHandler(transform, node, event) {
      this.SetAllObjectTransparency(1)
      this.objectChange(event, transform, node)
    },
    mouseDownHandler(transform, node) {
      this.setChildrenMaterielOpacity(transform, 0.65)

      // If this node is not present in the history yet then add it
      if (this.historyTransformArray.find(h => h.node.pid == node.pid) == undefined) {
        // Save rotation, position and rotation
        this.historyTransformArray.push({
          node: Object.assign({}, node),
          transform: transform,
          pos_x: parseFloat(transform.position.x.toFixed(3)),
          pos_y: parseFloat(transform.position.y.toFixed(3)),
          pos_z: parseFloat(transform.position.z.toFixed(3)),
          quaternion_x: transform.quaternion.x ? parseFloat(transform.quaternion.x.toFixed(3)) : undefined,
          quaternion_y: transform.quaternion.y ? parseFloat(transform.quaternion.y.toFixed(3)) : undefined,
          quaternion_z: transform.quaternion.z ? parseFloat(transform.quaternion.z.toFixed(3)) : undefined,
          quaternion_w: transform.quaternion.w ? parseFloat(transform.quaternion.w.toFixed(3)) : undefined,
          scale: transform.scale.x,
        })
      }
    },
    addTransformControls(transform, node) {
      var context = this
      this.transformControls = new TransformControls(this.currentCamera, this.renderer.domElement)
      this.transformControls.size = 1.4

      this.transformControls.addEventListener('change', this.render)
      this.transformControls.addEventListener('mouseDown', event => this.mouseDownHandler(transform, node))
      this.transformControls.addEventListener('objectChange', event => this.scaleChange(transform, node))
      this.transformControls.addEventListener('mouseUp', event => this.mouseUpHandler(transform, node, event))
      this.transformControls.addEventListener('dragging-changed', function(event) {
        context.orbit.enabled = !event.value
      })

      var gizmoRotateX = this.transformControls._gizmo.gizmo['rotate'].children.find(mesh => mesh.name == 'X')
      gizmoRotateX.material.color.setHex(0xab3741)

      var gizmoRotateY = this.transformControls._gizmo.gizmo['rotate'].children.find(mesh => mesh.name == 'Y')
      gizmoRotateY.material.color.setHex(0x87d68a)

      var gizmoTranslateX = this.transformControls._gizmo.gizmo['translate'].children.find(mesh => mesh.name == 'X')
      gizmoTranslateX.material.color.setHex(0x87d68a)

      var gizmoTranslateY = this.transformControls._gizmo.gizmo['translate'].children.find(mesh => mesh.name == 'Y')
      gizmoTranslateY.material.color.setHex(0xab3741)

      var gizmoTranslateZ = this.transformControls._gizmo.gizmo['translate'].children.find(mesh => mesh.name == 'Z')
      gizmoTranslateZ.material.color.setHex(0x4185d0)

      this.transformControls.attach(transform)
      this.transformControlDictionnary[node.pid] = this.transformControls
      this.changeTransformControl(this.controlMode)
      this.scene.add(this.transformControls)
      this.render()
    },

    async createHobjectsRepresentation() {
      for (const node of this.nodes) {
        var model = await this.createHobjectRepresentation(node)
        this.render()
        var box = new THREE.Box3().setFromObject(model)
        this.render()
        if (this.highest3dObject < box.max.y) this.highest3dObject = box.max.y
        this.render()
      }
      this.renderer.domElement.addEventListener('mousedown', this.onDocumentMouseDown, false)
    },
    createMeshArray(node, model) {
      var self = this
      model.traverse(function(child) {
        if (child.isMesh) {
          child.name = node.pid
          child.castShadow = true
          self.meshes.push(child)
        }
      })
    },
    async createHobjectRepresentation(node) {
      const hobject = this.getHobject(node.hobject_pid)
      const modelGroup = new THREE.Object3D()
      var model
      switch (hobject.model_identifier) {
        case 'hoverlay.core.Audio.1.0':
          model = await HoverlayThreeUtils.createCoreAudio(hobject, this.renderer, this.render)
          this.createMeshArray(node, model)
          modelGroup.add(model)
          break
        case 'hoverlay.core.UnityAssetBundle.1.0':
          model = await HoverlayThreeUtils.createCoreImage(hobject, this.renderer, this.render)
          this.createMeshArray(node, model)
          modelGroup.add(model)
          break
        case 'hoverlay.core.Button.1.0':
          model = await HoverlayThreeUtils.createCoreButton(hobject, modelGroup, this.gltfLoader)
          this.createMeshArray(node, model)
          modelGroup.add(model)
          break
        case 'hoverlay.core.TextCard.1.0':
        case 'hoverlay.core.Image.1.0':
          model = await HoverlayThreeUtils.createCoreImage(hobject, this.renderer, this.render)
          this.createMeshArray(node, model)
          modelGroup.add(model)
          break
        case 'hoverlay.core.Video.1.0':
        case 'hoverlay.core.ChromaVideo.1.0':
          model = await HoverlayThreeUtils.createCoreVideo(hobject, node, this.threeJSVideoComponents)
          this.createMeshArray(node, model)
          modelGroup.add(model)
          break
        case 'hoverlay.core.3dModel.1.0':
          model = await HoverlayThreeUtils.createCore3dModel(
            hobject,
            node,
            modelGroup,
            this.gltfLoader,
            this.mixerDictionnary
          )
          this.createMeshArray(node, model)

          modelGroup.add(model)
          break
        case 'hoverlay.core.Portal.1.0':
          var res = await HoverlayThreeUtils.createCorePortalThumbnail(
            hobject,
            node,
            this.renderer,
            this.render,
            this.threeJSVideoComponents
          )

          model = res.model
          this.createMeshArray(node, model, false)
          modelGroup.add(model)
          break
        default:
          break
      }
      const transform = new THREE.Group()

      // Setup pivot point
      // mesh.position.set(0, this.hobjectHeight / 2, 0)

      // Setup rotation
      if (
        isNaN(node.quaternion_x) ||
        isNaN(node.quaternion_y) ||
        isNaN(node.quaternion_z) ||
        isNaN(node.quaternion_w)
      ) {
        // Using euler
        // Setup rotation
        // transform.rotation.set(
        //   THREE.MathUtils.degToRad(-node.angle_x + 90),
        //   THREE.MathUtils.degToRad(-node.angle_y),
        //   THREE.MathUtils.degToRad(node.angle_z)
        // )
      } else {
        // Using quaternion
        var quaternion = new THREE.Quaternion(
          node.quaternion_x,
          node.quaternion_y,
          -node.quaternion_z,
          -node.quaternion_w
        )
        transform.quaternion.copy(quaternion) // Apply Quaternion
        transform.quaternion.normalize() // Normalize Quaternion
      }

      //Setup position
      transform.position.set(node.x, node.y, -node.z)

      //Set scale
      transform.scale.set(node.scale, node.scale, node.scale)

      transform.name = node.pid
      transform.add(modelGroup)
      this.transformDictionnary[node.pid] = transform

      const transformParent = new THREE.Group()
      transformParent.add(transform)
      this.scene.add(transformParent)
      transformParent.rotation.set(THREE.MathUtils.degToRad(+90), 0, 0)

      // this.scene.add(transform)

      // this.renderer.domElement.addEventListener('click', this.onDocumentMouseDown, false)
      return model
    },
    createMeshDictionnary(node, model) {
      var self = this
      model.traverse(function(child) {
        if (child.isMesh) {
          child.name = node.pid
          self.meshes.push(child)
        }
      })
    },
    adjustCameraDistance() {
      var fov = this.currentCamera.fov * (Math.PI / 180)
      var distance = Math.abs(this.highest3dObject / Math.sin(fov / 2))
      this.currentCamera.position.set(this.currentCamera.position.x, this.currentCamera.position.y, distance)
      this.orbit.maxDistance = distance * 5 // the maximum distance the camera must have from center
      this.orbit.update()
      this.currentCamera.lookAt(0, 0, 0)
    },
    changeTransformControl(mode) {
      switch (mode) {
        case 'translate':
          for (const control of Object.values(this.transformControlDictionnary)) {
            // console.log(control)
            control.setMode('translate')
            control.setSpace('world')
            control.showZ = true
            control.showX = true
            control.showY = true
          }
          break
        case 'scale':
          for (const control of Object.values(this.transformControlDictionnary)) {
            control.showZ = false
            control.showX = false
            control.showY = true
            control.setMode('scale')
            control.setSpace('local')
          }
          break
        case 'rotate':
          // Rotate
          for (const control of Object.values(this.transformControlDictionnary)) {
            control.showX = true
            control.showY = true
            control.showZ = true
            control.setMode('rotate')
            control.setSpace('local')
          }
          break
        default:
          break
      }
      this.render()
    },
    onDocumentMouseDown(event) {
      // void raycast if transform control has been used (avoid event propagation)
      if (this.transformControls != null && this.transformControls.axis != null) return

      var canvasPosition = this.renderer.domElement.getBoundingClientRect()
      var mouseX = event.clientX - canvasPosition.left
      var mouseY = event.clientY - canvasPosition.top
      var mouse = new THREE.Vector3(
        2 * (mouseX / this.renderer.domElement.clientWidth) - 1,
        1 - 2 * (mouseY / this.renderer.domElement.clientHeight),
        0.5
      )
      var raycaster = new THREE.Raycaster(
        this.currentCamera.position,
        mouse
          .unproject(this.currentCamera)
          .sub(this.currentCamera.position)
          .normalize()
      )

      var intersects = raycaster.intersectObjects(this.meshes, true)
      if (intersects.length > 0) {
        var nodePid = intersects[0].object.name
        var node = this.nodes.find(node => JSON.stringify(node.pid) == JSON.stringify(nodePid))
        if (!this.selectedNode || (node && node.pid != this.selectedNode.pid)) {
          // this.SetAllObjectTransparency(1)
          if (this.transformControls != null) {
            this.unregisterTransformControl()
            this.transformControls.detach()
            this.scene.remove(this.transformControls)
          }
          // this.setChildrenMaterielOpacity(this.transformDictionnary[nodePid], 0.65)
          this.addTransformControls(this.transformDictionnary[nodePid], node)
          this.$emit('selectedNode', node)
        }
      }
    },
    setChildrenMaterielOpacity(object, opacity) {
      object.traverse(function(child) {
        if (child.isMesh) {
          child.material.transparent = true
          child.material.opacity = opacity
        }
      })
    },
    async createTrackedImageRepresentation() {
      var trackedImage = await Utils.loadImage(this.getCloudfrontUrlFromS3(this.imageAnchor.data))

      this.trackedImagePixelWidth = trackedImage.naturalWidth
      this.trackedImagePixelHeight = trackedImage.naturalHeight

      var trackedImageHeight = JSON.parse(this.imageAnchor.mark).height
      if (trackedImageHeight > this.highest3dObject) this.highest3dObject = trackedImageHeight
      var trackedImageWidth = trackedImageHeight * (this.trackedImagePixelWidth / this.trackedImagePixelHeight)
      const texture = new THREE.TextureLoader().load(trackedImage.src, this.render)
      texture.anisotropy = this.renderer.capabilities.getMaxAnisotropy()
      const material = new THREE.MeshLambertMaterial({ map: texture, transparent: true, side: THREE.DoubleSide })
      material.opacity = 0.99

      const geometry = new THREE.PlaneGeometry(trackedImageWidth, trackedImageHeight, 32)
      const plane = new THREE.Mesh(geometry, material)

      // plane.rotation.set(THREE.MathUtils.degToRad(-90), 0, 0)

      plane.position.set(0, 0, -0.001)
      this.scene.add(plane)
    },
    // function triggered when user change the input transform values
    onNodePositionChanged(node) {
      var transform = this.transformDictionnary[node.pid]
      if (transform == null) return
      // change position if needed
      if (transform.position.x != node.x) transform.position.x = node.x
      if (transform.position.y != node.y) transform.position.y = node.y
      if (transform.position.z != -node.z) transform.position.z = -node.z
      // change scale if needed
      if (transform.scale.x != node.x || transform.scale.y != node.y || transform.scale.z != node.z) {
        transform.scale.z = node.scale
        transform.scale.x = node.scale
        transform.scale.y = node.scale
      }
      // change rotation if needed
      var transform_angle_x = parseInt(THREE.MathUtils.radToDeg(-transform.rotation.x))
      if (transform_angle_x != node.angle_x) {
        transform.rotation.x = THREE.MathUtils.degToRad(-node.angle_x)
      }
      var transform_angle_y = parseInt(THREE.MathUtils.radToDeg(-transform.rotation.y))
      if (transform_angle_y != node.angle_y) {
        transform.rotation.y = THREE.MathUtils.degToRad(-node.angle_y)
      }
      var transform_angle_z = parseInt(THREE.MathUtils.radToDeg(-transform.rotation.z))
      if (transform_angle_z != node.angle_z) {
        transform.rotation.z = THREE.MathUtils.degToRad(-node.angle_z)
      }
      this.mouseUpHandler(transform, node, null)
    },

    scaleChange(group, node) {
      node.scale = group.scale.x = group.scale.y = group.scale.z = Math.abs(group.scale.y)
      this.render()
    },
    objectChange(event, transform, node) {
      node.x = parseFloat(transform.position.x.toFixed(2))
      node.y = parseFloat(transform.position.y.toFixed(2))
      node.z = -parseFloat(transform.position.z.toFixed(2))
      node.angle_x = Math.round(parseFloat(THREE.MathUtils.radToDeg(-transform.rotation.x)))
      node.angle_y = Math.round(parseFloat(THREE.MathUtils.radToDeg(-transform.rotation.y)))
      node.angle_z = Math.round(parseFloat(THREE.MathUtils.radToDeg(-transform.rotation.z)))
      // Convert the quaternion before saving it in the database
      node.quaternion_x = transform.quaternion.x
      node.quaternion_y = transform.quaternion.y
      node.quaternion_z = -transform.quaternion.z
      node.quaternion_w = -transform.quaternion.w
      node.is_dirty = true

      this.historyTransformArray.push({
        node: Object.assign({}, node),
        transform: transform,
        pos_x: parseFloat(transform.position.x.toFixed(3)),
        pos_y: parseFloat(transform.position.y.toFixed(3)),
        pos_z: parseFloat(transform.position.z.toFixed(3)),
        quaternion_x: parseFloat(transform.quaternion.x.toFixed(3)),
        quaternion_y: parseFloat(transform.quaternion.y.toFixed(3)),
        quaternion_z: parseFloat(transform.quaternion.z.toFixed(3)),
        quaternion_w: parseFloat(transform.quaternion.w.toFixed(3)),
        scale: parseFloat(transform.scale.x),
      })
      this.$emit('checkIfNodesAreDirties')
    },
    onWindowResize() {
      this.CANVAS_HEIGHT = this.scene3d.offsetHeight
      this.CANVAS_WIDTH = this.scene3d.offsetWidth

      const aspect = this.CANVAS_WIDTH / this.CANVAS_HEIGHT

      this.cameraPersp.aspect = aspect
      this.cameraPersp.updateProjectionMatrix()

      this.cameraOrtho.left = this.cameraOrtho.bottom * aspect
      this.cameraOrtho.right = this.cameraOrtho.top * aspect
      this.cameraOrtho.updateProjectionMatrix()

      this.renderer.setSize(this.CANVAS_WIDTH, this.CANVAS_HEIGHT)

      this.render()
    },
    render() {
      if (this.threeJSVideoComponents)
        this.threeJSVideoComponents.forEach(el => {
          if (el.video.readyState == el.video.HAVE_ENOUGH_DATA) {
            el.videoImageContext.drawImage(el.video, 0, 0)
            if (el.videoTexture) el.videoTexture.needsUpdate = true
          }
        })
      this.renderer.render(this.scene, this.currentCamera)
    },
    reset() {
      this.setupScene()
      this.render()
    },
    getHobject(hobject_pid) {
      return JSON.parse(
        JSON.stringify(this.$store.state.hoverlay.hobjects.filter(hobject => hobject.pid == hobject_pid)[0])
      )
    },
    unregisterTransformControl() {
      this.transformControls && this.transformControls.removeEventListener('change', this.render)
      this.transformControls && this.transformControls.removeEventListener('mouseDown', this.mouseDownHandler)

      this.transformControls && this.transformControls.removeEventListener('mouseUp', this.mouseUpHandler)
      this.transformControls && this.transformControls.removeEventListener('objectChange', this.mouseUpHandler)
      this.transformControls && this.transformControls.removeEventListener('objectChange', this.scaleChange)
      this.transformControls && this.transformControls.removeEventListener('dragging-changed', this.onDraggingChanged)
    },
    animate() {
      const mixerUpdateDelta = this.clock.getDelta()
      if (this.mixerDictionnary)
        for (const mixer of Object.values(this.mixerDictionnary)) {
          mixer.update(mixerUpdateDelta)
        }
      this.requestAnimationFrameId = requestAnimationFrame(this.animate)
      this.render()
    },
    Repeat() {},
    Undo() {
      if (this.historyTransformArrayIndex > 0) this.historyTransformArrayIndex -= 1
      var h = this.historyTransformArray[this.historyTransformArrayIndex]
      if (h == undefined) return

      var node = this.nodes.find(n => n.pid == h.node.pid)

      // Undo transform on the threejs view
      h.transform.position.set(h.pos_x, h.pos_y, h.pos_z)
      h.transform.scale.set(h.scale, h.scale, h.scale)

      var quaternion = new THREE.Quaternion(h.quaternion_x, h.quaternion_y, h.quaternion_z, h.quaternion_w)
      h.transform.quaternion.copy(quaternion) // Apply Qus  aternion
      h.transform.quaternion.normalize() // Normalize Quaternion

      // Undo transform inside the
      node.x = h.pos_x
      node.y = h.pos_y
      node.z = -h.pos_z
      node.quaternion_x = h.quaternion_x
      node.quaternion_y = h.quaternion_y
      node.quaternion_z = -h.quaternion_z
      node.quaternion_z = -h.quaternion_w
      node.scale = h.scale

      // If we reach the begining of the history clean it
      if (this.historyTransformArrayIndex == 0) {
        this.historyTransformArray.splice(1)

        this.nodes.forEach(n => {
          if (n.was_saved == true) {
            n.is_dirty = true
            n.was_saved = false
          } else n.is_dirty = false
        })
      } else {
        this.nodes.forEach(n => {
          n.is_dirty = true
        })
      }
    },
    radToDeg(radians) {
      var pi = Math.PI
      return radians * (180 / pi)
    },
    SetAllObjectTransparency(transparencyValue) {
      for (const transform of Object.values(this.transformDictionnary)) {
        this.setChildrenMaterielOpacity(transform, transparencyValue)
      }
    },
  },
}
</script>

<style lang="scss">
#div-with-loading {
  height: 50px;
  width: 50px;
}
#div-with-loading > .con-vs-loading {
  background-color: rgba(255, 255, 128, 0);
}
.center-top-right-loading {
  right: 0;
  text-align: right;
  position: absolute;
  top: 0;
}

.center-top-right {
  right: 0;
  width: 300px;
  text-align: right;
  position: absolute;
  top: 0;
  padding-right: 10px;
}

.center-top-left {
  width: 50px;
  text-align: left;
  position: absolute;
  padding-left: 10px;
  top: 0;
}

.center-bottom-left {
  width: 200x;
  text-align: left;
  position: absolute;
  padding-left: 10px;
  bottom: 0;
}

.no-padding {
  padding: 0rem !important;
}
.card-no-padding > .vx-card__collapsible-content > .vx-card__body {
  padding: 0rem !important;
}

.scene3d {
  height: 550px;
  background: transparent;
}
</style>
